import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectVisitorContact } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import ContactModalShell from './ContactModalShell';

interface Props {
    ticketKey?: TicketKey;
}

const TicketContactModal = ({ ticketKey }: Props) => {
    const contact = useAppSelector((state) =>
        ticketKey ? selectVisitorContact(state, ticketKey) : undefined,
    );

    return <ContactModalShell contact={contact} />;
};

export default TicketContactModal;
